<template>
    <div id="ringdiagram" :style="{ height: '100%'}"></div>
</template>
<script >
import { cmsSysCloudlsdCountPlatform,cmsSysCloudlsdCountCountryfindAll } from '../../../../api/home.js'
export default {
    name: "",
    components: {},
    props: ['intervalRefreshDate'],
    
    data() {
        return {
            timer: null
        };
    },
    watch: {},
    computed: {},
    methods: {
        // async init() {
        //     const res = await cmsSysCloudlsdCountPlatform()
        //     console.log(res.data,1111111111)
        // },
        async drawLine() {
            // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
            let myChart = this.$echarts.init(document.getElementById('ringdiagram'))
            // 绘制图表

            let option = {
                // backgroundColor: "#000911",
                polar: {
                    radius: ['61%', '57%'],
                    center: ['50%', '50%'],
                },


                title: {
                    zlevel: 0,
                    text: "平台占比",
                    // subtext: '平台占比',
                    top: '45%',
                    left: '50%',
                    textAlign: 'center',
                    textStyle: {
                        color: '#fff',
                        fontSize: 25,
                    },
                    subtextStyle: {
                        fontSize: 40,
                        color: '#fff',
                    },
                },
                angleAxis: {
                    max: 1,
                    show: false,
                    startAngle: 0,
                },
                radiusAxis: {
                    type: 'category',
                    show: true,
                    axisLabel: { show: false },
                    axisLine: { show: false },
                    axisTick: { show: false },
                },
                series: [
                    // 外层刻度
                    {

                        hoverAnimation: false,
                        type: 'pie',
                        z: 2,
                        data: [],
                        radius: ['65%', '73%'],
                        center: ['50%', '50%'],

                        zlevel: -2,
                        label: {
                            normal: {
                                position: 'inside',
                                show: false,
                            },
                        },

                    },

                    // 内层饼图
                    {
                        type: 'pie',
                        radius: ['59%', '60%'],
                        center: ['50%', '50%'],
                        data: [],
                        labelLine: {
                            length: 40,
                        },
                        // 提示线设置
                        label: {
                            show: true,
                            formatter: '{a|{b}}\n{hr|}\n {per|{d}%} ',
                            // formatter:(data)=>{
                            //     console.log(data)
                            //     // return `{a|{c}}\n{hr|}\n {per|{d}%}`
                            // },

                            backgroundColor: 'rgba(0, 0, 0, 0)',
                            borderColor: 'rgba(0, 0, 0, 0)',
                            borderWidth: 1,
                            borderRadius: 4,


                            rich: {
                                a: {
                                    color: '#fff',
                                    lineHeight: 26,
                                    align: 'center',
                                    fontSize: 14,
                                },
                                hr: {
                                    borderColor: 'auto',
                                    width: '100%',
                                    borderWidth: 1,
                                    height: 0,
                                },
                                per: {
                                    color: 'auto',
                                    backgroundColor: 'rgba(0, 0, 0, 0)',
                                    padding: [5, 5],
                                    borderRadius: 4,
                                    fontSize: 16,
                                }
                            }
                        },

                    },
                    // 内二层饼图
                    {

                        type: 'pie',

                        radius: ['49%', '50%'],
                        center: ['50%', '50%'],
                        color: ['#02101f', '#fff', '#091b31', '#fff'],
                        data: [25, 25, 25, 25],

                        label: {
                            show: false
                        }
                    },

                ]
            }
            // let chartData = [
            //     { color: '#f7cd36', data: 28, ratio: '0', name: '测试1' },
            //     { color: '#00f6c4', data: 25, ratio: '0', name: '测试2' },
            //     { color: '#285cbd', data: 8, ratio: '0', name: '测试3' },
            //     { color: '#42c55e', data: 12, ratio: '0', name: '测试4' },
            //     { color: '#7456c2', data: 27, ratio: '0', name: '测试5' },
            // ]
            let chartData = []
            let colors = ["#f7cd36", "#00f6c4", "#285cbd", "#42c55e", "#7456c2"]


          

            try {
                // const res = await cmsSysCloudlsdCountPlatform()
                const res=  await cmsSysCloudlsdCountCountryfindAll({
            pageNum:1,
            pageSize:99
           })
                res.data.records.forEach((item, index) => {
                    const { platformName, proportion } = item;
                    chartData.push({ data: Number(proportion.split('%')[0]), name: platformName, color: colors[index] })
                });
            } catch (err) {
                this.$message.error("数据加载失败")
            }



            let total = 100
            chartData.map(item => {

                if (item.data > 0) {
                    let num = Math.round((item.data / total) * 40)
                    for (let i = 0; i < num; ++i) {

                        option.series[0].data.push({
                            value: 2, // 有颜色部分的宽度
                            name: i,
                            ratio: item.ratio,
                            itemStyle: {
                                normal: { color: item.color, }
                            },
                        }, {
                            value: 1, // 无颜色部分的宽度
                            name: '',
                            itemStyle: {
                                normal: {
                                    label: { show: false },
                                    labelLine: { show: false },
                                    color: 'rgba(0, 0, 0, 0)',
                                    borderColor: 'rgba(0, 0, 0, 0)',
                                    borderWidth: 0,
                                }
                            }
                        })
                    }
                }
                // 内层饼图数据
                option.series[1].data.push({
                    hoverOffset: 1,
                    value: item.data,
                    name: item.name,
                    itemStyle: { color: item.color },
                })
            })
            // 如果总数据为0时，每个颜色的值设为25%（本文实现的是四色图），可视具体情况而定
            if (total == 0) {
                chartData.map(item => {
                    for (let i = 0; i < 25; ++i) {
                        option.series[0].data.push({
                            value: 2,
                            name: i,
                            ratio: item.ratio,
                            itemStyle: {
                                normal: { color: item.color, }
                            },
                        }, {
                            value: 1,
                            name: '',
                            itemStyle: {
                                normal: {
                                    label: { show: false },
                                    labelLine: { show: false },
                                    color: 'rgba(0, 0, 0, 0)',
                                    borderColor: 'rgba(0, 0, 0, 0)',
                                    borderWidth: 0
                                }
                            }
                        })
                    }
                })

            }




            myChart.clear();
            myChart.setOption(option);
        }
    },
    
    created() { },
    async mounted() {
        await this.drawLine();
        this.timer = setInterval(async () => {
            await this.drawLine();
        }, this.intervalRefreshDate)

    },
    beforeDestroy() {
        console.log("销毁定时器")
        //2.销毁前清除定时器
        clearInterval(this.timer);
    },
}
</script>
<style lang="scss" scoped>

</style>